import type { CardData, CollectionEntry, CollectionSummary, RarityTier } from '../types/card';

export function upsertCollectionEntry(
  entries: CollectionEntry[],
  card: CardData,
  pulledAt = new Date().toISOString()
): CollectionEntry[] {
  const existing = entries.find((entry) => entry.card.id === card.id);

  if (!existing) {
    return [
      {
        card,
        count: 1,
        firstPulledAt: pulledAt,
        lastPulledAt: pulledAt
      },
      ...entries
    ];
  }

  return entries.map((entry) =>
    entry.card.id === card.id
      ? {
          ...entry,
          card,
          count: entry.count + 1,
          lastPulledAt: pulledAt
        }
      : entry
  );
}

export function sortCollection(entries: CollectionEntry[]): CollectionEntry[] {
  return [...entries].sort((left, right) => {
    const rarityScore = rarityRank(right.card.rarity) - rarityRank(left.card.rarity);
    if (rarityScore !== 0) {
      return rarityScore;
    }

    return left.card.name.localeCompare(right.card.name);
  });
}

export function summarizeCollection(entries: CollectionEntry[]): CollectionSummary {
  const byRarity: Record<RarityTier, number> = {
    common: 0,
    uncommon: 0,
    rare: 0,
    epic: 0,
    legendary: 0
  };

  let totalCards = 0;
  for (const entry of entries) {
    byRarity[entry.card.rarity] += 1;
    totalCards += entry.count;
  }

  return {
    totalCards,
    uniqueCards: entries.length,
    byRarity
  };
}

function rarityRank(rarity: RarityTier): number {
  switch (rarity) {
    case 'legendary':
      return 5;
    case 'epic':
      return 4;
    case 'rare':
      return 3;
    case 'uncommon':
      return 2;
    case 'common':
      return 1;
  }
}

